import Navbar from "@/components/dendros/Navbar";
import Hero from "@/components/dendros/Hero";
import Problem from "@/components/dendros/Problem";
import Solution from "@/components/dendros/Solution";
import HowItWorks from "@/components/dendros/HowItWorks";
import Trust from "@/components/dendros/Trust";
import Founders from "@/components/dendros/Founders";
import FooterCTA from "@/components/dendros/FooterCTA";
import SiteFooter from "@/components/dendros/SiteFooter";

export default function Landing() {
    return (
        <main
            data-testid="landing-page"
            className="relative min-h-screen bg-[#050505] text-white overflow-x-hidden"
        >
            <Navbar />
            <Hero />
            <Problem />
            <Solution />
            <HowItWorks />
            <Trust />
            <Founders />
            <FooterCTA />
            <SiteFooter />
        </main>
    );
}
